import React from "react";

const About = () => (
    <div className="m-5 about-con">
        <div className="m-5">
            <p className="h-6 about">
                Experience the immersive simulation of real-life environments with the app. By harnessing
                the power of web audio API and convolution, it brings you life like sounds from various physical places,
                allowing you to feel as if you're actually there. To ensure an optimal experience, make sure to use
                headphones or a sound setup to prevent any feedback loops.
                <br />
                <br />
                As a sound artist, my passion lies in preserving the essence of physical spaces through the art of
                capturing impulse responses. I aim to contribute to a shared repository of these unique sound archives.
                <br />
                <br />
                Impulse data from <a href="https://openairlib.net">OpenAirLib</a>, a project from the university of york
                and EchoThief impulse response library.
                <br />
                <br />
                I am currently setting up a process for anyone to be able to add an impulse response for a place to the
                respository. If you would like to do that now, you could mail me at jayantmanchanda1@gmail.com
                <br />
            </p>
        </div>
    </div>
);
export default About;
